import React, { useMemo } from "react";
import { Spin } from "antd";
import { FaBox } from "react-icons/fa";
import styled from "styled-components";

function FilterMenu(props) {
  const pageCount = [5, 25, 50, 75, 100, 150, 200];
  const { page, totals, countPage } = props;

  return (
    <FilterMenuStyle className="row mx-2 ">
      <div className="px-1 filterMenu">
        <div className="firstBlock">
          {props.iconComponent ? (
            props.iconComponent
          ) : props.icon ? (
            <img
              src={props.icon}
              width="30"
              style={{ color: "#cacaca", marginRight: "4px", opacity: "0.5" }}
            />
          ) : (
            <FaBox size={30} style={{ color: "#cacaca", marginRight: "4px" }} />
          )}
          {props.loading ? (
            <div>
              Loading...
              <Spin className="ml-2" />
            </div>
          ) : [page, totals, countPage].every(
              (val) => typeof val == "number"
            ) ? (
            <CoutPagination {...{ page, totals, countPage }}>
              <span className="filterMenuText first">
                Total{" "}
                {props.noLowerCase ? props.text2 : props.text2.toLowerCase()}
              </span>
            </CoutPagination>
          ) : (
            <>
              <span className="filterMenuText first">
                Total{" "}
                {props.noLowerCase ? props.text2 : props.text2.toLowerCase()}
              </span>
              <span className="firstLength">
                {props.totals == "loading" ? (
                  <Spin />
                ) : props.totals ? (
                  `${props.length}/${props.totals}`
                ) : (
                  props.length
                )}
              </span>
            </>
          )}
          {props.customText && <div className="ml-4">{props.customText}</div>}
        </div>
        {props.children}
        {!!props.countPage && !!props.onChangeCountPage && (
          <div>
            <span className="filterMenuText">{props.text2} in page </span>
            <select
              value={props.countPage}
              onChange={(e) => props.onChangeCountPage(+e.target.value)}
            >
              {pageCount.map((item) => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {props.tableLayout && (
          <div>
            <span className="filterMenuText">
              Table{" "}
              <span
                className="underline"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  props.tableLayout.openModal("LayoutOfTablesModal")
                }
              >
                layout
              </span>
            </span>
          </div>
        )}
        {props.tableLayout && (
          <div>
            <span className="filterMenuText">
              Filter by{" "}
              <span
                className="underline"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  props.tableLayout.openModal("SupplierFilterModal")
                }
              >
                shipping to customer
              </span>
            </span>
          </div>
        )}
        {props.categoryFilterModal && (
          <div>
            <span className="filterMenuText">
              Filter by{" "}
              <span
                className="underline"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  props.categoryFilterModal.openModal("CategoryFilterModal")
                }
              >
                categories
              </span>
            </span>
          </div>
        )}
        {props.statusFilter && (
          <div>
            <span className="filterMenuText">
              Filter by{" "}
              <span
                className="underline"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  props.statusFilter.openModal("StatusFilterModal")
                }
              >
                status
              </span>
            </span>
          </div>
        )}
        {props.custom}
      </div>
    </FilterMenuStyle>
  );
}

const CoutPagination = ({
  children,
  page: pageNumber,
  totals: totalItems,
  countPage: itemsPerPage,
}) => {
  const [startItem, endItem] = useMemo(() => {
    const startItem = (pageNumber - 1) * itemsPerPage + 1;
    const endItem = Math.min(pageNumber * itemsPerPage, totalItems);

    return [startItem, endItem];
  }, [pageNumber, totalItems, itemsPerPage]);

  return (
    <div>
      {children}
      <span className="firstLength">
        {totalItems == 0 && startItem == 1
          ? "0"
          : `${startItem} - ${endItem}/${totalItems}`}
      </span>
    </div>
  );
};

const FilterMenuStyle = styled.div`
  .filterMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .filterMenuText {
      font-size: 10px;
      line-height: 14px;
      color: #212121;
      font-weight: 400;
      padding-right: 9px;
      & .underline {
        font-weight: 900;
        border-bottom: 1px solid #212121;
      }
    }

    & select {
      border: 1px solid #f2f2f2;
      background-color: transparent;
      border-radius: 5px;
      padding: 4px 4px;
      font-size: 10px;

      line-height: 14px;
      color: #454545;
      font-weight: 400;
    }

    .firstBlock {
      display: flex;
      align-items: center;
      & .first {
        font-size: 13px;
        line-height: 14px;
        color: #727272;
        font-weight: 400;
        padding-right: 9px;
        margin-left: 10px;
      }
      & .firstLength {
        color: #212121;
        font-weight: 400;
        font-size: 18px;
      }
    }
  }
`;

export default FilterMenu;
